var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestionCircle = function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 13.5a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.5 5.25a1.5 1.5 0 0 1 3 0C8.5 6.355 7 6.75 7 8M7 10.25a.25.25 0 0 1 0-.5M7 10.25a.25.25 0 0 0 0-.5"
  }))));
};
export default SvgQuestionCircle;